import { AppData, Log, Utils } from '@lightningjs/sdk'
import { AppSetup } from '../app-setup'
import { Helper } from '../helper'
import axios from 'axios'
import { ItemNode } from '../components/grid/ItemNode'
import { DRM_TYPE } from '../enum'
import { PLATFORM } from '../enum'

export const getFetchUrl = (dataURL: string, useApiProxy = false) => {
    const { appConfig, platform, appState } = AppData as AppSetup
    const app = appState?.getApp()
    const { userConfig } = app?.appApiConfig!
    let apiBaseUrl = appConfig?.enableDirectApiCall ? appConfig?.apiUrl : appConfig?.apiPath
    if(useApiProxy) {
        apiBaseUrl = appConfig?.apiPath
    }
    Log.info('apiBaseUrl: ', apiBaseUrl)
    // if (dataURL.indexOf('index.php') !== -1) {
    //   fetchDataUrl = dataURL
    // } else if (dataURL.indexOf('sub-categories.php') !== -1) {
    //   fetchDataUrl = dataURL
    // } else if (dataURL.indexOf('getSuggestions.php') !== -1) {
    //   fetchDataUrl = dataURL
    // } else if (dataURL.indexOf('ajax.php') !== -1) {
    //   fetchDataUrl = dataURL
    // } else if (dataURL.indexOf('promoapps.php') !== -1) {
    //   fetchDataUrl =
    //     'promoapps.php?' +
    //     '&keys=' +
    //     Helper.urlParam('keys', dataURL) +
    //     '&appId=' +
    //     Helper.urlParam('appId', dataURL) +
    //     '&siteId=' +
    //     Helper.urlParam('siteId', dataURL) +
    //     '&auth-token=' +
    //     Helper.urlParam('auth-token', dataURL) +
    //     '&version=' +
    //     Helper.urlParam('version', dataURL) +
    //     '&deviceId=' +
    //     Helper.urlParam('deviceId', dataURL) +
    //     //+ '&session-id=' + Helper.urlParam('session-id', dataURL)
    //     '&sort_type=' +
    //     Helper.urlParam('sort_type', dataURL) +
    //     '&order=' +
    //     Helper.urlParam('order', dataURL) +
    //     '&highlight=' +
    //     Helper.urlParam('highlight', dataURL) +
    //     '&akp=' +
    //     Helper.urlParam('akp', dataURL) +
    //     '&start-index=' +
    //     Helper.urlParam('start-index', dataURL)
    // } else if (dataURL.indexOf('promo-content.php') !== -1) {
    //   fetchDataUrl = dataURL
    // } else if (dataURL.indexOf('recipes.php') !== -1 || dataURL.indexOf('getQueuelist.php') !== -1) {
    //   let apiName = 'recipes.php?'
    //   if (dataURL.indexOf('getQueuelist.php') !== -1) {
    //     apiName = 'getQueuelist.php?'
    //   }
    //   fetchDataUrl =
    //     apiName +
    //     '&searchType=' +
    //     Helper.urlParam('searchType', dataURL) +
    //     '&keys=' +
    //     Helper.urlParam('keys', dataURL) +
    //     '&appId=' +
    //     Helper.urlParam('appId', dataURL) +
    //     '&siteId=' +
    //     Helper.urlParam('siteId', dataURL) +
    //     '&auth-token=' +
    //     Helper.urlParam('auth-token', dataURL) +
    //     '&version=' +
    //     Helper.urlParam('version', dataURL) +
    //     '&deviceId=' +
    //     Helper.urlParam('deviceId', dataURL) +
    //     //+ '&session-id=' + Helper.urlParam('session-id', dataURL)
    //     '&sort_type=' +
    //     Helper.urlParam('sort_type', dataURL) +
    //     '&order=' +
    //     Helper.urlParam('order', dataURL) +
    //     '&highlight=' +
    //     Helper.urlParam('highlight', dataURL) +
    //     '&akp=' +
    //     Helper.urlParam('akp', dataURL) +
    //     '&start-index=' +
    //     Helper.urlParam('start-index', dataURL)
    //   if (Helper.urlParam('max-results', dataURL) !== '') {
    //     fetchDataUrl += '&max-results=' + Helper.urlParam('max-results', dataURL)
    //   }
    // } else if (dataURL.indexOf('addQueue.php') !== -1) {
    //   fetchDataUrl =
    //     'addQueue.php?' +
    //     '&appId=' +
    //     Helper.urlParam('appId', dataURL) +
    //     '&siteId=' +
    //     Helper.urlParam('siteId', dataURL) +
    //     '&auth-token=' +
    //     Helper.urlParam('auth-token', dataURL) +
    //     '&version=' +
    //     Helper.urlParam('version', dataURL) +
    //     '&deviceId=' +
    //     Helper.urlParam('deviceId', dataURL) +
    //     '&session-id=' +
    //     Helper.urlParam('session-id', dataURL) +
    //     (dataURL.indexOf('videoId=') !== -1
    //       ? '&videoId=' + Helper.urlParam('videoId', dataURL)
    //       : '') +
    //     (dataURL.indexOf('showId=') !== -1 ? '&showId=' + Helper.urlParam('showId', dataURL) : '')
    // } else if (dataURL.indexOf('removeQueue.php') !== -1) {
    //   fetchDataUrl =
    //     'removeQueue.php?' +
    //     '&appId=' +
    //     Helper.urlParam('appId', dataURL) +
    //     '&siteId=' +
    //     Helper.urlParam('siteId', dataURL) +
    //     '&auth-token=' +
    //     Helper.urlParam('auth-token', dataURL) +
    //     '&version=' +
    //     Helper.urlParam('version', dataURL) +
    //     '&deviceId=' +
    //     Helper.urlParam('deviceId', dataURL) +
    //     '&session-id=' +
    //     Helper.urlParam('session-id', dataURL) +
    //     (dataURL.indexOf('videoId=') !== -1
    //       ? '&videoId=' + Helper.urlParam('videoId', dataURL)
    //       : '') +
    //     (dataURL.indexOf('showId=') !== -1 ? '&showId=' + Helper.urlParam('showId', dataURL) : '')
    // } else if (dataURL.indexOf('clearSolrHistory.php') !== -1) {
    //   fetchDataUrl =
    //     'clearSolrHistory.php?' +
    //     '&appId=' +
    //     Helper.urlParam('appId', dataURL) +
    //     '&siteId=' +
    //     Helper.urlParam('siteId', dataURL) +
    //     '&auth-token=' +
    //     Helper.urlParam('auth-token', dataURL) +
    //     '&auth-key=' +
    //     '1solr123' +
    //     '&version=' +
    //     Helper.urlParam('version', dataURL) +
    //     '&deviceId=' +
    //     Helper.urlParam('deviceId', dataURL) +
    //     '&session-id=' +
    //     Helper.urlParam('session-id', dataURL)
    // } else if (dataURL.indexOf('shows.php') !== -1) {
    //   fetchDataUrl =
    //     'shows.php?' +
    //     '&searchType=' +
    //     Helper.urlParam('searchType', dataURL) +
    //     '&keys=' +
    //     Helper.urlParam('keys', dataURL) +
    //     '&appId=' +
    //     Helper.urlParam('appId', dataURL) +
    //     '&siteId=' +
    //     Helper.urlParam('siteId', dataURL) +
    //     '&auth-token=' +
    //     Helper.urlParam('auth-token', dataURL) +
    //     '&version=' +
    //     Helper.urlParam('version', dataURL) +
    //     '&deviceId=' +
    //     Helper.urlParam('deviceId', dataURL) +
    //     //+ '&session-id=' + Helper.urlParam('session-id', dataURL)
    //     '&sort_type=' +
    //     Helper.urlParam('sort_type', dataURL) +
    //     '&order=' +
    //     Helper.urlParam('order', dataURL) +
    //     '&highlight=' +
    //     Helper.urlParam('highlight', dataURL) +
    //     '&akp=' +
    //     Helper.urlParam('akp', dataURL) +
    //     '&start-index=' +
    //     Helper.urlParam('start-index', dataURL)
    // } else if (dataURL.indexOf('testlive.json') !== -1) {
    //   fetchDataUrl = dataURL
    // } else {
    //   fetchDataUrl = dataURL
    // }
    let fetchDataUrl = Helper.getPathFromUrl(dataURL)
    if (Helper.urlParam('dltype', dataURL) == '') {
        const { appConfig } = app?.appApiConfig!
        if (appConfig && appConfig.dltype) {
            fetchDataUrl += '&dltype=' + appConfig.dltype
        }

        // XFIN-1295 - Fix for dltype param
        // else {
        //     fetchDataUrl += '&dltype=1'
        // }
    }
    if (Helper.urlParam('deviceId', dataURL) == '') {
        fetchDataUrl += '&deviceId=' + platform?.getDeviceId()
    }
    if (Helper.urlParam('gridstyle', dataURL) == '') {
        const { appConfig } = app?.appApiConfig!
        if (appConfig && appConfig.gridstyle) {
            fetchDataUrl += '&gridstyle=' + appConfig.gridstyle
        }
    }
    if (appConfig?.testCountry !== '') {
        fetchDataUrl = fetchDataUrl + '&country=' + appConfig?.testCountry
    } else {
        if (userConfig?.countryCode && userConfig?.countryCode !== '') {
            fetchDataUrl = fetchDataUrl + '&country=' + userConfig.countryCode
        }
    }
    // if (Helper.urlParam('gridstyle', dataURL) !== '' && appState?.getAppApiConfig()?.userConfig?.countryCode !== '') {
    //   fetchDataUrl = fetchDataUrl + '&country=' + appState?.getAppApiConfig()?.userConfig?.countryCode
    // }
    // if (appState?.appApiConfig?.userConfig. && appState.userInfo.sid && appState.userInfo.sid != '') {
    //   fetchDataUrl = fetchDataUrl + '&session-id=' + appState.userInfo.sid
    // }
    fetchDataUrl = fetchDataUrl + '&acontent=' + appConfig?.aContent
    fetchDataUrl = fetchDataUrl + `&r=${new Date().getTime()}`
    if (appConfig?.apiEnv !== '') {
        fetchDataUrl = fetchDataUrl + '&apiEnv=' + appConfig?.apiEnv
    }
    Log.info('fetchDataUrl: ', (apiBaseUrl + fetchDataUrl))
    if(appConfig?.testSubCategoryError) {
        if (dataURL.indexOf('sub-categories.php') !== -1) {
            dataURL = 'https://sub-categories_404.php'
            return dataURL
            //dataURL = dataURL.split('sub-categories.php').join('sub-categories_404.php')
        }
    }
    return apiBaseUrl + fetchDataUrl
}

export const fetchData = function (url: string, disableToken = false): Promise<any> {
    const { appConfig } = AppData as AppSetup
    const isAppLoggerRequest = url.includes('applogger.php');

    const axiosConfig: any = {
        url,
    };
    if (appConfig?.enableSecurityToken && !isAppLoggerRequest && !appConfig?.testDisableToken && !disableToken) {
        axiosConfig.headers = {
            'token': `${appConfig?.securityToken}`
        };
    }

    return axios(axiosConfig)
    .then((response) => {
        try{
            if(response && response.data && response.data.data && response.data.data.code=="5002" && response.data.data.description && response.data.data.description=="Unauthorized access.") {
                Helper.removeCookie('_token');
                if(!appConfig?.testDisableToken){
                    window.location.reload();
                }
                return null;
            }
        } catch(e){

        }

        // You can transform or validate response here
        return response; // optional transformation
    })
    .catch(error => {
        const { platform } = AppData as AppSetup
        platform?.sendMetrics('error', {errorType: 'API_ERROR', code: 'API_ERROR', description:error.message})
        Helper.removeCookie('_token');
        throw error;
    })
}

export const getCommonParams = (apiVersionForce?: string, authToken?: string) => {
    const { appConfig, platform, appState } = AppData as AppSetup
    let jsonParams = '&auth-token=' + (authToken || appConfig?.platform_id)
    jsonParams += '&appId=' + appConfig?.appId
    jsonParams += '&version=' + (apiVersionForce || appConfig?.apiVersion)
    jsonParams += '&siteId=' + appState?.getApp()?.siteId
    jsonParams += '&deviceId=' + platform?.getDeviceId()
    jsonParams += '&format=json'
    return jsonParams
}

export const getIndexUrl = (siteId: string): string => {
    const { appConfig } = AppData as AppSetup
    return getFetchUrl(
        `index.php?siteId=${siteId}&platform_id=${appConfig?.platform_id}${getCommonParams()}`,
    )
}

export const getDeviceIp = (): Promise<string> => {
    return new Promise((resolve) => {
        const url = getFetchUrl(`get-ip.php?`)
        fetchData(url)
            .then((data) => {
                resolve(data.data)
            })
            .catch((e) => {
                resolve('')
            })
    })
}

export const getSiteConfig = (): Promise<any> => {
    const { appConfig } = AppData as AppSetup
    return new Promise((resolve) => {
        const url = getFetchUrl(`get-config.php?platform_id=${appConfig?.platform_id}&nodeEnv=${appConfig?.nodeEnv}`, true)
        fetch(url)
            .then((response) => response.json().then(data=>resolve(data)))
            .catch((e) => {
                resolve(null)
            })
    })
}

export const initSecurityToken = (): Promise<any> => {
    const { appConfig } = AppData as AppSetup
    return new Promise((resolve) => {
        const url = getFetchUrl(`getSecurityToken.php?platform_id=${appConfig?.platform_id}${getCommonParams()}`,true)
        fetch(url)
            .then((response) => response.json().then(data=>resolve(data)))
            .catch((e) => {
                resolve(null)
            })
    })
}

export const getSearchSuggestion = (searchStr: string, pageNo: any): string => {
    const { appConfig } = AppData as AppSetup
    if(searchStr == '') {
        return getFetchUrl(
            `/getSuggestions.php?searchType=suggestion&keys=popular&platform_id=${appConfig?.platform_id}${getCommonParams()}&start-index=${pageNo}&`
        );
    } else {
        return getFetchUrl(
            `/getSuggestions.php?searchType=suggestion&keys=${searchStr}&platform_id=${appConfig?.platform_id}${getCommonParams()}&start-index=${pageNo}&`
        );
    }
};

export const clearRecentlyWatched = (nodeId?: string) => {
    let url = `/clearSolrHistory.php?${getCommonParams()}&auth-key=1solr123`;
    if (nodeId) {
        url += `&videoId=${nodeId}`;
    }
    return getFetchUrl(url);
}

export const getDRMSERVICEURL = (drmType:DRM_TYPE): string => {
    const { appConfig, platform, appState } = AppData as AppSetup
    let token = '';
    if (appConfig?.enableSecurityToken) {
        token = `&token=${appConfig?.securityToken}`;
    }
    let retUrl = getFetchUrl(`/drmService.php?drm_type=${drmType}&platform_id=${appConfig?.platform_id}${getCommonParams()}${token}`,true)
    /*if(retUrl.indexOf('version=sv9.0') !== -1) {
        retUrl = retUrl.replace('version=sv9.0', `version=sv6.0`)
    }*/
    return retUrl
    /*if(appConfig?.useApiProxyForDrm) {
        const retUrl = getFetchUrl(`/drmService.php?drm_type=${drmType}&platform_id=${appConfig?.platform_id}${getCommonParams()}`)
        return retUrl
    } else {
        return `https://rapi.ifood.tv/drmService.php?&drm_type=${drmType}&${getCommonParams()}`
    }*/
}

export const getDRMURL = (): string => {
    const { appConfig } = AppData as AppSetup
    return getFetchUrl(
        `drm.php?platform_id=${appConfig?.platform_id}${getCommonParams()}`,
    )
}

export const getBookmarkingData = (vodItem: ItemNode) => {
    const { appConfig } = AppData as AppSetup
    const retUrl = getFetchUrl(`/recipes.php?searchType=bookmark&keys=${vodItem.id}&platform_id=${appConfig?.platform_id}${getCommonParams()}`)
    return retUrl
}


export const getSearchItemUrl = (searchStr: string): string => {
    const { appConfig } = AppData as AppSetup
    if(searchStr == '') {
        return `/recipes.php?searchType=popular&platform_id=${appConfig?.platform_id}${getCommonParams()}`
    } else {
        return `/recipes.php?searchType=search&keys=${searchStr}&platform_id=${appConfig?.platform_id}${getCommonParams()}`
    }
}

export const getSimilarVideosUrl = (nodeId: string): string => {
    const { appConfig } = AppData as AppSetup
    return `/recipes.php?searchType=similar&keys=${nodeId}&platform_id=${appConfig?.platform_id}${getCommonParams()}`
}

export const getQueueItemUrl = (): string => {
    return getFetchUrl(
        `/getQueuelist.php?${getCommonParams()}&max-results=100`
    );
}

export const addToQueue = (type: any, id: any): string => {
    let url = '/addQueue.php?' + getCommonParams();
    if (type == 'video') {
        url += '&videoId=' + id;
    } else {
        url += '&showId=' + id;
    }
    return getFetchUrl(
        url
    )
}

export const getBlocksUrl = (itemId:any, contentType:any) => {
    return getFetchUrl(
        `/blockitem.php?itemId=${itemId}&contentType=${contentType}&${getCommonParams()}`
    );
}

export const getUnblocksUrl = (itemId:any, contentType:any) => {
    return getFetchUrl(
        `/unblockitem.php?itemId=${itemId}&contentType=${contentType}&${getCommonParams()}`
    );
}

export const removeFromQueue = (type: any, id: any, clearAll: boolean = false): string => {
    let url = '/removeQueue.php?' + getCommonParams();
    if(clearAll) {
        url += '&auth-key=637ca6fe2a2093dc&clearall=true'
    } else {
        if (type == 'video') {
            url += '&videoId=' + id;
        } else {
            url += '&showId=' + id;
        }
    }
    return getFetchUrl(
        url
    )
}

export const getPolicy = (searchStr: string): string => {
    const { appConfig } = AppData as AppSetup
    return `/recipes.php?searchType=search&keys=${searchStr}&platform_id=${appConfig?.platform_id}${getCommonParams()}`
}

export const getPolicyUrl = (searchStr: string): string => {
    const { appConfig, platform } = AppData as AppSetup
    let platformId = appConfig.platform_id
    let url = getFetchUrl(`/recipes.php?searchType=generaldesc&search&keys=${searchStr}&platform_id=${platformId}${getCommonParams()}`)
    //temprovary fix for vizio as we are getting the html tags from the api response
    //we will be using the comcast platform id and when using the different platform
    //secutity call fails hence changing the version to sv6.0 for api error.
    if(appConfig.platform_id == PLATFORM.VIZIO) {
        platformId = PLATFORM.COMCAST
        url = getFetchUrl(`/recipes.php?searchType=generaldesc&search&keys=${searchStr}&platform_id=${platformId}${getCommonParams('sv6.0', platformId)}`)
    }
    return url
}

export const getPromoContentUrl = (key: string): string => {
    const { appState } = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    return `/promo-content.php?type=video&${getCommonParams()}&key=${key}&gridstyle=${appApiConfig?.appConfig.gridstyle}`;
}

export const getTrickPlayUrl = (node_id: string): string => {
    const { appConfig } = AppData as AppSetup
    const apiBaseUrl = appConfig?.apiPath
    let token = '';
    if (appConfig?.enableSecurityToken) {
        token = `&token=${appConfig?.securityToken}`;
    }
    return `${apiBaseUrl}/tp.php?${getCommonParams()}&feedId=${node_id}${token}`;
}

export const getImage = (url: string) => {
    if(!url && url=='') {
        return '';
    }
    const { appConfig } = AppData as AppSetup
    const apiBaseUrl = appConfig?.apiPath
    const uri = `${apiBaseUrl}/getImage.php?url=${encodeURIComponent(url)}`
    return uri
}

export const fetchMultiRequest = async (urls:string[]) => {
    const { appConfig} = AppData as AppSetup
    const apiBaseUrl = appConfig?.apiPath
    const uri = `${apiBaseUrl}multifetch.php`
    const results  = await axios.post(uri,JSON.stringify(urls))
    return results
}

export const postLikeDislikeUrl = (itemId:any, itemType: string, likeValue: number) => {
    return getFetchUrl(
        `/likedislike.php?itemId=${itemId}&like_val=${likeValue}&item_type=${itemType}&${getCommonParams()}`
    );
}

window.fetchMultiRequest = fetchMultiRequest
